module.exports = __webpack_public_path__ + "static/media/IdCard.75d049dc.png";